var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.layout)?_c(_vm.layout,{tag:"component"}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }